<style scoped>

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: Arial;
}

p {
  margin: 0;
}

.row {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  -ms-flex-wrap: wrap; /* IE10 */
  flex-wrap: wrap;
  padding: 0;
}

/* Create four equal columns that sits next to each other */
.column {
  -ms-flex: 25%; /* IE10 */
  flex: 25%;
  max-width: 25%;
  padding: 0;
}

.column img {
  margin-top: 0px;
  vertical-align: middle;
  width: 100%;
}

/* Responsive layout - makes a two column-layout instead of four columns */
@media screen and (max-width: 800px) {
  .column {
    -ms-flex: 50%;
    flex: 50%;
    max-width: 50%;
  }
}


#worksgrid {
  margin-top: 2rem;
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .column {
    -ms-flex: 100%;
    flex: 100%;
    max-width: 100%;
  }
  #worksgrid {
    margin-top: .25rem;
  }
}


.works {
  background-color: white;
  background-repeat: repeat;
  text-align: left;
}



.hovbox {
  position: relative;
  width: 100%;
}

.projectimage {
  opacity: 1;
  width: 100%;
}

.imglist {
  padding: .25rem;
}

.logo {
  opacity: 1;
  width: 100%;
  position: relative;

}

.thumbnail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  opacity: .25;
  /*filter: grayscale(100%);*/
  transition: 1s ease;

}

.hovbox:hover .thumbnail {
    opacity: 1;
}

.hovbox:hover .logo {
  opacity: 0;
}



</style>

<template>
  <div class="works">
    <div class="container-fluid">
      <div class="row">
        <Nav></Nav>
      </div>

<!-- Photo Grid -->
<div class="row" id="worksgrid">
  <div class="column ONE">
    <!--<h6>KINGPOWER</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/KingPower/KingPower1.jpg" data-type="image" data-fancybox="kingpower" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/KingPower.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/KingPowerLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/KingPower/KingPower2.jpg" data-type="image" data-fancybox="kingpower" data-caption=""></a>
      <a href="../Projects/KingPower/KingPower3.jpg" data-type="image" data-fancybox="kingpower" data-caption=""></a>
      <a href="../Projects/KingPower/KingPower4.jpg" data-type="image" data-fancybox="kingpower" data-caption=""></a>
    </p>

    <!--<h6>TACOBELL</h6>-->
    <p class="imglist" style="width: 100%;">
      <a data-fancybox href="https://youtu.be/pmPfP68Fgvs" data-fancybox="tacobell" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Tacobell.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/TacobellLogo.png" style="width:100%;">
        </div>
      </a>
      <a data-fancybox href="https://youtu.be/wnHaH2X1KqA" data-fancybox="tacobell" data-caption=""></a>
      <a data-fancybox href="https://youtu.be/kU-Ud2R3H1Y" data-fancybox="tacobell" data-caption=""></a>
      <a data-fancybox href="https://youtu.be/CuzzoeilCg0" data-fancybox="tacobell" data-caption=""></a>
      <a data-fancybox href="https://youtu.be/qc_bfp99Jl8" data-fancybox="tacobell" data-caption=""></a>
      <a href="../Projects/TACOBELL/TACOBELL6.jpg" data-type="image" data-fancybox="tacobell" data-caption=""></a>
      <a href="../Projects/TACOBELL/TACOBELL7.gif" data-type="image" data-fancybox="tacobell" data-caption=""></a>
      <a href="../Projects/TACOBELL/TACOBELL8.gif" data-type="image" data-fancybox="tacobell" data-caption=""></a>
      <a href="../Projects/TACOBELL/TACOBELL9.gif" data-type="image" data-fancybox="tacobell" data-caption=""></a>
      <a href="../Projects/TACOBELL/TACOBELL11.jpg" data-type="image" data-fancybox="tacobell" data-caption=""></a>
      <a href="../Projects/TACOBELL/TACOBELL13.jpg" data-type="image" data-fancybox="tacobell" data-caption=""></a>
      <a href="../Projects/TACOBELL/TACOBELL14.gif" data-type="image" data-fancybox="tacobell" data-caption=""></a>
    </p>

    <!--<h6>COCA</h6>-->
    <p class="imglist" style="width: 100%;">
      <a data-fancybox href="https://youtu.be/vrCaCfH1Bj8" data-fancybox="coca" data-caption="">
        <div class="hovbox" style="overflow: hidden;">
          <img class="thumbnail" src="http://i3.ytimg.com/vi/vrCaCfH1Bj8/mqdefault.jpg" defer style="height:100%; width:auto; left: -50%; overflow: hidden;"/>
          <img class="logo" src="/ProjectLogos/CocaLogo.png" style="width:100%;">
        </div>
      </a>
    </p>

    <!--<h6>CONNELL</h6>-->
    <p class="imglist" style="width: 100%;">
      <a data-fancybox href="https://youtu.be/FjK1nhAZtjA" data-fancybox="connell" data-caption="">
        <div class="hovbox" style="overflow: hidden;">
          <img class="thumbnail" src="http://i3.ytimg.com/vi/FjK1nhAZtjA/mqdefault.jpg" defer style="height:100%; width:auto; left: -50%; overflow: hidden;"/>
          <img class="logo" src="/ProjectLogos/ConnellLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/CONNELL/Connell01.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell02.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell03.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell04.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell05.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell06.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell07.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell08.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell09.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell10.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell11.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell12.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
      <a href="../Projects/CONNELL/Connell13.jpg" data-type="image" data-fancybox="connell" data-caption=""></a>
    </p>

    <!--<h6>DBB</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/DDB/DDB1.jpg" data-type="image" data-fancybox="ddb" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/DDB.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/DDBLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/DDB/DDB2.jpg" data-type="image" data-fancybox="ddb" data-caption=""></a>
      <a href="../Projects/DDB/DDB3.jpg" data-type="image" data-fancybox="ddb" data-caption=""></a>
      <a href="../Projects/DDB/DDB4.jpg" data-type="image" data-fancybox="ddb" data-caption=""></a>
    </p>

    <!--<h6>SHOENVIOUS</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/SHOENVIOUS/Shoenvious1.jpg" data-type="image" data-fancybox="shoenvious" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Shoenvious.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/ShoenviousLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/SHOENVIOUS/Shoenvious2.jpg" data-type="image" data-fancybox="shoenvious" data-caption=""></a>
      <a href="../Projects/SHOENVIOUS/Shoenvious3.jpg" data-type="image" data-fancybox="shoenvious" data-caption=""></a>
    </p>

  </div>
  <div class="column TWO">
    <!--<h6>FWD INSURANCE REGIONAL CAMPAIGN</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/FWD/FWD1.jpg" data-type="image" data-fancybox="FWD" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/FWD.jpg" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/FWDLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/FWD/FWD2.jpg" data-type="image" data-fancybox="FWD" data-caption="">
        </a>
      <a href="../Projects/FWD/FWD3.jpg" data-type="image" data-fancybox="FWD" data-caption="">
        </a>
      <a href="../Projects/FWD/FWD4.jpg" data-type="image" data-fancybox="FWD" data-caption="">
        </a>
    </p>

    <!--<h6>BECTERO</h6>-->
    <p class="imglist" style="width: 100%;">
      <a data-fancybox href="https://youtu.be/vCNOc1asbPs" data-fancybox="bectero" data-caption="">
        <div class="hovbox" style="overflow: hidden;">
          <img class="thumbnail" src="http://i3.ytimg.com/vi/vCNOc1asbPs/mqdefault.jpg" defer style="height:100%; width:auto; left: -50%; overflow: hidden;"/>
          <img class="logo" src="/ProjectLogos/BECteroLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/BECtero/BECTERO1.jpeg" data-type="image" data-fancybox="bectero" data-caption=""></a>
      <a href="../Projects/BECtero/BECTERO2.jpeg" data-type="image" data-fancybox="bectero" data-caption=""></a>
      <a href="../Projects/BECtero/BECTERO3.jpeg" data-type="image" data-fancybox="bectero" data-caption=""></a>
      <a href="../Projects/BECtero/BECTERO4.jpeg" data-type="image" data-fancybox="bectero" data-caption=""></a>
      <a href="../Projects/BECtero/BECTERO5.jpeg" data-type="image" data-fancybox="bectero" data-caption=""></a>
      <a href="../Projects/BECtero/BECTERO6.jpeg" data-type="image" data-fancybox="bectero" data-caption=""></a>
    </p>

    <!--<h6>SULWHASOO</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/Sulwhasoo/41730533_1004532413066951_1185002067039617024_o.jpg" data-type="image" data-fancybox="sulwhasoo" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Sulwhasoo.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/SulwhasooLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/Sulwhasoo/41747587_1004524849734374_8310238758247071744_o.jpg" data-type="image" data-fancybox="sulwhasoo" data-caption="">
        <img class="projectimage" src="/Projects/Sulwhasoo/41747587_1004524849734374_8310238758247071744_o.jpg" style="width:240px; display:none;"/>
      </a>
      <a href="../Projects/Sulwhasoo/41748687_1004528889733970_126060034621702144_o.jpg" data-type="image" data-fancybox="sulwhasoo" data-caption="">
        <img class="projectimage" src="/Projects/Sulwhasoo/41748687_1004528889733970_126060034621702144_o.jpg" style="width:240px; display:none;"/>
      </a>
    </p>

    <!--<h6>MANGO TREE</h6>-->
    <p class="imglist" style="width: 100%;">

      <a data-fancybox href="https://youtu.be/_EWgSHbn3FU" data-fancybox="mangotree" data-caption="">
        <div class="hovbox" style="overflow: hidden;">
          <img class="thumbnail" src="/ProjectThumbnails/Mangotree.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/MangotreeLogo.png" style="width:100%;">
        </div>
      </a>
      <a data-fancybox href="https://youtu.be/8bKAqP739gk" data-fancybox="mangotree" data-caption=""></a>
      <a href="../Projects/MangoTree/MangoTree1.png" data-type="image" data-fancybox="mangotree" data-caption=""></a>
      <a href="../Projects/MangoTree/MangoTree2.png" data-type="image" data-fancybox="mangotree" data-caption=""></a>
      <a href="../Projects/MangoTree/MangoTree3.jpg" data-type="image" data-fancybox="mangotree" data-caption=""></a>
    </p>

    <!--<h6>ROCKET FUEL</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/Rocketfuel/Rocketfuel1.jpg" data-type="image" data-fancybox="rf" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/RF.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/RFLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/Rocketfuel/Rocketfuel2.jpg" data-type="image" data-fancybox="rf" data-caption=""></a>
      <a href="../Projects/Rocketfuel/Rocketfuel3.jpg" data-type="image" data-fancybox="rf" data-caption=""></a>
      <a href="../Projects/Rocketfuel/Rocketfuel4.jpg" data-type="image" data-fancybox="rf" data-caption=""></a>
    </p>

    <!--<h6>ANCHA</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/ANCHA/ANCHA1.jpeg" data-type="image" data-fancybox="ancha" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Ancha.jpg" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/AnchaLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../../Projects/ANCHA/ANCHA2.jpeg" data-type="image" data-fancybox="ancha" data-caption=""></a>
      <a href="../../Projects/ANCHA/ANCHA3.jpeg" data-type="image" data-fancybox="ancha" data-caption=""></a>
      <a href="../../Projects/ANCHA/ANCHA4.JPG" data-type="image" data-fancybox="ancha" data-caption=""></a>
      <a href="../../Projects/ANCHA/ANCHA5.JPG" data-type="image" data-fancybox="ancha" data-caption=""></a>
    </p>

  </div>

  <div class="column THREE">
    <!--<h6>GRAB SOCIAL MEDIA CAMPAIGN</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/Grab/GRAB1.PNG" data-type="image" data-fancybox="grab" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Grab.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/GrabLogo.png">
        </div>
      </a>
      <a href="../Projects/Grab/GRAB2.jpg" data-type="image" data-fancybox="grab" data-caption=""></a>
      <a href="../Projects/Grab/GRAB3.jpg" data-type="image" data-fancybox="grab" data-caption=""></a>
      <a href="../Projects/Grab/GRAB4.jpg" data-type="image" data-fancybox="grab" data-caption=""></a>
      </p>

    <!--<h6>ALCON</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/ALCON/Alcon1.jpg" data-type="image" data-fancybox="alcon" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Alcon.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/AlconLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/ALCON/Alcon2.jpg" data-type="image" data-fancybox="alcon" data-caption=""></a>
    </p>

    <!--<h6>OCHA</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/OCHA/OCHA1.jpeg" data-type="image" data-fancybox="ocha" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/OCHA.jpg" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/OCHALogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/OCHA/OCHA2.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA3.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA4.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA5.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA6.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA7.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA8.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA9.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA10.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA11.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA12.jpeg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA13.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA14.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA15.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA16.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA17.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA18.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA19.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA20.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA21.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>
      <a href="../Projects/OCHA/OCHA22.jpg" data-type="image" data-fancybox="ocha" data-caption=""></a>

    </p>

    <!--<h6>HOPPER</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/Hopper/HOPPER1.jpeg" data-type="image" data-fancybox="hopper" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Hopper.jpg" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/HopperLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/Hopper/HOPPER2.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER3.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER4.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER5.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER6.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER7.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER8.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER9.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER10.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER11.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER12.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER13.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
      <a href="../Projects/Hopper/HOPPER14.jpeg" data-type="image" data-fancybox="hopper" data-caption=""></a>
    </p>

    <!--<h6>BECCAR</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/BECCAR/BECCAR1.jpg" data-type="image" data-fancybox="beccar" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Beccar.jpg" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/BeccarLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/BECCAR/BECCAR2.jpg" data-type="image" data-fancybox="beccar" data-caption=""></a>
      <a href="../Projects/BECCAR/BECCAR3.jpg" data-type="image" data-fancybox="beccar" data-caption=""></a>
    </p>

    <!--<h6>GENTLEPARK</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/GentlePark/GentlePark1.jpg" data-type="image" data-fancybox="gentlepark" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/GTP.jpg" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/GTPLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/GentlePark/GentlePark2.jpg" data-type="image" data-fancybox="gentlepark" data-caption=""></a>
      <a href="../Projects/GentlePark/GentlePark3.jpg" data-type="image" data-fancybox="gentlepark" data-caption=""></a>
      <a href="../Projects/GentlePark/GentlePark4.jpg" data-type="image" data-fancybox="gentlepark" data-caption=""></a>
      <a href="../Projects/GentlePark/GentlePark5.jpg" data-type="image" data-fancybox="gentlepark" data-caption=""></a>
    </p>

  </div>
  <div class="column FOUR">

    <p class="imglist" style="width: 100%;">
      <a href="../Projects/StIves/StIves1.gif" data-type="image" data-fancybox="stives" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/StIves.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/StIvesLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/StIves/StIves2.gif" data-type="image" data-fancybox="stives" data-caption=""></a>
      <a href="../Projects/StIves/StIves3.jpg" data-type="image" data-fancybox="stives" data-caption=""></a>
      <a href="../Projects/StIves/StIves4.jpg" data-type="image" data-fancybox="stives" data-caption=""></a>
      <a href="../Projects/StIves/StIves5.jpg" data-type="image" data-fancybox="stives" data-caption=""></a>
      <a href="../Projects/StIves/StIves6.jpg" data-type="image" data-fancybox="stives" data-caption=""></a>
      <a href="../Projects/StIves/StIves7.jpg" data-type="image" data-fancybox="stives" data-caption=""></a>
    </p>

    <!--<h6>RTL</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/RTL/RTL1.jpeg" data-type="image" data-fancybox="rtl" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/RTL.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/RTLLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/RTL/RTL2.jpeg" data-type="image" data-fancybox="rtl" data-caption=""></a>
      <a href="../Projects/RTL/RTL3.jpeg" data-type="image" data-fancybox="rtl" data-caption=""></a>
      <a href="../Projects/RTL/RTL4.jpeg" data-type="image" data-fancybox="rtl" data-caption=""></a>
      <a href="../Projects/RTL/RTL5.jpeg" data-type="image" data-fancybox="rtl" data-caption=""></a>
      <a href="../Projects/RTL/RTL6.jpg" data-type="image" data-fancybox="rtl" data-caption=""></a>
      <a href="../Projects/RTL/RTL7.jpg" data-type="image" data-fancybox="rtl" data-caption=""></a>
      <a href="../Projects/RTL/RTL8.jpg" data-type="image" data-fancybox="rtl" data-caption=""></a>
      <a href="../Projects/RTL/RTL9.jpg" data-type="image" data-fancybox="rtl" data-caption=""></a>
    </p>




    <!--<h6>REDTAPE</h6>-->
    <p class="imglist" style="width: 100%;">
      <a data-fancybox href="https://youtu.be/c9YxB0UfB5E" data-fancybox="redtape" data-caption="">
        <div class="hovbox" style="overflow: hidden;">
          <img class="thumbnail" src="http://img.youtube.com/vi/c9YxB0UfB5E/mqdefault.jpg" defer style="height:100%; width:auto; left: -50%; overflow: hidden;"/>
          <img class="logo" src="/ProjectLogos/RedTapeLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/RedTape/RedTape1.jpg" data-type="image" data-fancybox="redtape" data-caption=""></a>
      <a href="../Projects/RedTape/RedTape2.jpg" data-type="image" data-fancybox="redtape" data-caption=""></a>
      <a href="../Projects/RedTape/RedTape3.jpg" data-type="image" data-fancybox="redtape" data-caption=""></a>
      <a href="../Projects/RedTape/RedTape4.jpg" data-type="image" data-fancybox="redtape" data-caption=""></a>
    </p>


    <!--<h6>AGODA</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/Agoda/AGODA1.jpeg" data-type="image" data-fancybox="agoda" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/Agoda.jpg" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/AgodaLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/Agoda/AGODA2.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA3.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA4.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA5.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA6.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA7.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA8.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA9.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA10.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA11.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA12.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA13.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA14.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA15.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA16.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA17.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
      <a href="../Projects/Agoda/AGODA18.jpeg" data-type="image" data-fancybox="agoda" data-caption=""></a>
    </p>

    <!--<h6>9LINES</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/9Lines/9LINES1.jpg" data-type="image" data-fancybox="9lines" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/9lines.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/9linesLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/9Lines/9LINES2.jpg" data-type="image" data-fancybox="9lines" data-caption=""></a>
      <a href="../Projects/9Lines/9LINES3.jpg" data-type="image" data-fancybox="9lines" data-caption=""></a>
      <a href="../Projects/9Lines/9LINES4.jpg" data-type="image" data-fancybox="9lines" data-caption=""></a>
      <a href="../Projects/9Lines/9LINES5.jpg" data-type="image" data-fancybox="9lines" data-caption=""></a>
    </p>

    <!--<h6>WASHIT</h6>-->
    <p class="imglist" style="width: 100%;">
      <a href="../Projects/WASHIT/WASHIT1.jpg" data-type="image" data-fancybox="washit" data-caption="">
        <div class="hovbox">
          <img class="thumbnail" src="/ProjectThumbnails/WASHIT.png" defer style="width:100%;"/>
          <img class="logo" src="/ProjectLogos/WASHITLogo.png" style="width:100%;">
        </div>
      </a>
      <a href="../Projects/WASHIT/WASHIT2.jpg" data-type="image" data-fancybox="washit" data-caption=""></a>
      <a href="../Projects/WASHIT/WASHIT3.jpg" data-type="image" data-fancybox="washit" data-caption=""></a>
      <a href="../Projects/WASHIT/WASHIT4.jpg" data-type="image" data-fancybox="washit" data-caption=""></a>
    </p>
  </div>
</div>

<!-- DEATH BY PLASTIC

      <h6>#DEATHBYPLASTIC SOCIAL CHANGE PROJECT</h6>
      <p class="imglist" style="max-width: 1000px;">
        <a data-fancybox href="https://youtu.be/cGrXs-pxf-U">
        <img class="projectimage card-img-top img-fluid" src="http://img.youtube.com/vi/cGrXs-pxf-U/mqdefault.jpg" style="width:240px;"/>
        </a>
        <a data-fancybox href="https://youtu.be/bE92TRP6XNU">
        <img class="projectimage card-img-top img-fluid" src="http://img.youtube.com/vi/bE92TRP6XNU/mqdefault.jpg" style="width:240px;"/>
        </a>
        <a data-fancybox href="https://youtu.be/foVwPfdBg6E">
        <img class="projectimage card-img-top img-fluid" src="http://img.youtube.com/vi/foVwPfdBg6E/mqdefault.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP1big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP1big.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP2big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP2big.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP3big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP3big.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP4big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP4big.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP5big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP5big.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP6big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP6big.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP7big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP7big.jpg" style="width:240px;"/>
        </a>
        <a href="../Projects/DeathByPlastic/DBP8big.jpg" data-type="image" data-fancybox="images" data-caption="">
          <img class="projectimage" src="/Projects/DeathByPlastic/DBP8big.jpg" style="width:240px;"/>
        </a>
        </p>

      -->

    </div>
  </div>
</div>

</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import $ from 'jquery'

export default {
  name: 'works',
  components: {
    Nav
  }
}
</script>
